import axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";

import { CallDetailResultFromAPI } from "../types";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

export function useGetCallsAndAlertsById(
  eventId?: string,
  options?: UseQueryOptions<CallDetailResultFromAPI, any>
) {
  const marginCallsApiURL = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_MARGIN_CALLS}`;

  const fetchMarginCall = async () => {
    const { data } = await axios.get(`${marginCallsApiURL}/${eventId}`, {
      withCredentials: true,
    });
    return data as CallDetailResultFromAPI;
  };

  return useQuery<CallDetailResultFromAPI, AxiosError>(
    [queryKeys.getMarginCall],
    fetchMarginCall,
    {
      ...options,
    }
  );
}
